document.addEventListener('DOMContentLoaded', () => {
    console.log('[HulkApps] Custom script initialized. Attaching listeners...');
    attachListeners();

    const targetElement = document.querySelector('.collection__dynamic-part');
    if (targetElement) {
        const observer = new MutationObserver(() => {
            console.log('[HulkApps] DOM mutation detected. Re-attaching listeners...');
            attachListeners();
        });
        observer.observe(targetElement, { childList: true });
    }
});

function attachListeners() {
    document.querySelectorAll('.product-list .product-item__action-button.button--ternary').forEach((button) => {
        // Prevent duplicate listener attachment
        if (button.dataset.hulkListenerAttached === 'true') return;
        button.dataset.hulkListenerAttached = 'true';

        button.addEventListener('click', () => {
            const productIdInput = button.nextElementSibling;
            if (!productIdInput) return;
            const productId = productIdInput.value;
            
            console.log(`[HulkApps] Quick View triggered for Product ID: ${productId}`);

            const polling = setInterval(() => {
                const activeModal = document.querySelector(".modal:not(.is-loading)[aria-hidden='false']");
                if (!activeModal) return;

                const atcButton = activeModal.querySelector(".product-form__add-button");
                if (atcButton) {
                    clearInterval(polling);
                    console.log('[HulkApps] Active Quick View modal detected. Injecting custom options...');

                    const infoList = atcButton.closest('.product-form__buy-buttons');
                    const atcContainer = infoList.closest('form, .product-form, .product__info-container')?.querySelector('.product-form__info-list');

                    if (atcContainer && !activeModal.querySelector(`#hulkapps_custom_options_${productId}`)) {
                        const newHulkContainer = document.createElement('div');
                        newHulkContainer.id = `hulkapps_custom_options_${productId}`;
                        newHulkContainer.setAttribute('data-product-id', productId);
                        atcContainer.before(newHulkContainer);
                    }

                    if (typeof window.hulkapps_jQuery === 'function') {
                        const $ = window.hulkapps_jQuery;

                        // =====================================================================
                        // 🛡️ HULK JQUERY SHIELD: PREVENT NaN & GRID OVERWRITES
                        // =====================================================================
                        if (!$.fn.hulkPatchedForNaN) {
                            console.log('[HulkApps] Applying jQuery patch to prevent NaN and grid price overwrites.');
                            const originalHtml = $.fn.html;
                            const originalText = $.fn.text;

                            const isProtectedGridPrice = function(element) {
                                if (!element) return false;
                                const isPrice = element.hasClass('price') || element.hasClass('money') || element.parents('.price-list').length > 0;
                                const inActiveModal = element.closest(".modal[aria-hidden='false']").length > 0;
                                return isPrice && !inActiveModal; 
                            };

                            $.fn.html = function(value) {
                                if (typeof value === 'string' && value.includes('NaN')) {
                                    console.warn('[HulkApps Shield] Blocked an attempt to inject NaN via .html()');
                                    return this; 
                                }
                                if (window.hulkapps && window.hulkapps.is_quick_view && isProtectedGridPrice(this)) {
                                    console.warn('[HulkApps Shield] Blocked an attempt to overwrite collection grid price via .html()');
                                    return this; 
                                }
                                return originalHtml.apply(this, arguments);
                            };

                            $.fn.text = function(value) {
                                if (typeof value === 'string' && value.includes('NaN')) {
                                    console.warn('[HulkApps Shield] Blocked an attempt to inject NaN via .text()');
                                    return this; 
                                }
                                if (window.hulkapps && window.hulkapps.is_quick_view && isProtectedGridPrice(this)) {
                                    console.warn('[HulkApps Shield] Blocked an attempt to overwrite collection grid price via .text()');
                                    return this; 
                                }
                                return originalText.apply(this, arguments);
                            };
                            $.fn.hulkPatchedForNaN = true;
                        }
                        // =====================================================================

                        window.hulk_add_to_cart_ele = $(atcButton);

                        if (typeof window.hulkapps !== 'undefined') {
                            window.hulkapps.product = {}; 
                            window.hulkapps.product_id = productId;
                            window.hulkapps.page_type = 'product';
                            window.hulkapps.is_quick_view = true; 

                            if (typeof window.productPageAjax === 'function') {
                                console.log('[HulkApps] Firing productPageAjax for Quick View...');
                                window.productPageAjax($);
                                if (typeof window.calculateAndUpdateHulkPrice === 'function') {
                                    setTimeout(function() {
                                        window.calculateAndUpdateHulkPrice(productId);
                                    }, 1000);
                                }
                            }
                        }
                    } else {
                        console.error('[HulkApps] hulkapps_jQuery is not defined. App might be disabled.');
                    }
                }
            }, 100);
        });
    });
}